export const transportSchema = {
  title: 'Transport schema',
  description: 'Describes transport',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    createdAt: {
      type: 'number',
    },
    updatedAt: {
      type: 'number',
    },
    name: {
      type: 'string',
      minimum: 0,
    },
    owners: {
      type: 'array',
      items: {
        type: 'number',
      },
    },
  },
  required: ['id', 'name'],
}
